import { render, staticRenderFns } from "./PythagoreanSquareTraitPairView.vue?vue&type=template&id=1c38c91a&scoped=true&"
import script from "./PythagoreanSquareTraitPairView.vue?vue&type=script&lang=ts&"
export * from "./PythagoreanSquareTraitPairView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38c91a",
  null
  
)

export default component.exports